import { defineComponent as D, computed as I, openBlock as l, createBlock as y, unref as s, withCtx as o, createVNode as d, createElementVNode as a, createTextVNode as n, createCommentVNode as f, pushScopeId as T, popScopeId as $, createElementBlock as b, normalizeClass as x, toDisplayString as w, Fragment as k, renderList as E } from "vue";
import { CdrGrid as P, CdrImg as L, CdrText as c, CdrLink as R, CdrTable as V, IconWarningFill as Y } from "@rei/cedar";
const K = () => !!(window != null && window.metrics), O = (e) => {
  var t, p;
  K() && ((p = (t = window == null ? void 0 : window.metrics) == null ? void 0 : t.link) == null || p.call(t, e));
}, B = (e) => (T("data-v-67297a54"), e = e(), $(), e), q = /* @__PURE__ */ B(() => /* @__PURE__ */ a("span", {
  class: "rewards-table__footer-copy-header-mc-sup"
}, "®", -1)), z = /* @__PURE__ */ B(() => /* @__PURE__ */ a("span", {
  class: "rewards-table__footer-copy-header-mc-sup"
}, "®", -1)), C = "your account:dashboard_rei co-op mastercard", U = /* @__PURE__ */ D({
  __name: "RewardsFooterBanner",
  props: {
    showFooter: {
      type: Boolean,
      default: !1
    },
    rewardsDropExp: {
      type: String,
      required: !1,
      default: "control"
    }
  },
  setup(e) {
    const t = e, p = I(() => t.showFooter && t.rewardsDropExp !== "control"), _ = (u) => {
      O({
        linkName: u
      });
    };
    return (u, h) => p.value ? (l(), y(s(P), {
      key: 0,
      class: "rewards-table__footer-grid"
    }, {
      default: o(() => [d(s(L), {
        src: "https://www.rei.com/assets/credit-card/capital-one/mastercard-image/live.png",
        class: "rewards-table__footer-image",
        alt: "REI Co-op Mastercard"
      }), a("div", null, [d(s(c), {
        class: "rewards-table__footer-copy-header-mc",
        tag: "h2"
      }, {
        default: o(() => [n(" The REI CO-op"), q, n(" Mastercard"), z]),
        _: 1
      }), d(s(c), {
        class: "rewards-table__footer-copy-header"
      }, {
        default: o(() => [n(" Earn more rewards—and redeem them faster! ")]),
        _: 1
      }), t.rewardsDropExp === "variant-A" ? (l(), y(s(c), {
        key: 0,
        class: "rewards-table__footer-copy-subhead",
        "data-analytics-config": "exclude-all"
      }, {
        default: o(() => [n(" Earn 5% on REI purchases and 1.5% everywhere else—and redeem your rewards as soon as they post to your account! Terms apply. "), d(s(R), {
          href: "membership/mastercard?trackingId=reward-table-banner-test-learn",
          "data-ui": "rewards-breakdown-footer-banner-va-link",
          onClick: h[0] || (h[0] = (g) => _(`${C}_learn more`))
        }, {
          default: o(() => [n(" Learn more ")]),
          _: 1
        })]),
        _: 1
      })) : t.rewardsDropExp === "variant-B" ? (l(), y(s(c), {
        key: 1,
        class: "rewards-table__footer-copy-subhead",
        "data-analytics-config": "exclude-all"
      }, {
        default: o(() => [n(" Earn 5% on REI purchases and 1.5% everywhere else—and redeem your rewards as soon as they post to your account! Terms apply. "), d(s(R), {
          href: "membership/mastercard?trackingId=reward-table-banner-test-pre-approval",
          "data-ui": "rewards-breakdown-footer-banner-vb-link",
          onClick: h[1] || (h[1] = (g) => _(`${C}_see if you’re pre-approved`))
        }, {
          default: o(() => [n(" See if you're pre-approved ")]),
          _: 1
        }), n(" with no risk to your credit score. ")]),
        _: 1
      })) : f("", !0)])]),
      _: 1
    })) : f("", !0);
  }
});
const F = (e, t) => {
  const p = e.__vccOpts || e;
  for (const [_, u] of t)
    p[_] = u;
  return p;
}, W = /* @__PURE__ */ F(U, [["__scopeId", "data-v-67297a54"]]), j = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}), G = (e) => {
  const t = e.split(/-/);
  return `${t[1]}/${t[2]}/${t[0]}`;
}, A = (e) => (T("data-v-a160c5a3"), e = e(), $(), e), H = {
  class: "membership-rewards-table"
}, J = {
  class: "membership-rewards-table__caption"
}, Q = {
  class: "membership-rewards-table__caption__flex"
}, X = {
  class: "membership-rewards-table__caption__text"
}, Z = /* @__PURE__ */ A(() => /* @__PURE__ */ a("div", {
  class: "membership-rewards-table__caption__rei-rewards"
}, "REI Rewards", -1)), ee = {
  class: "membership-rewards-table__caption__balance",
  "data-ui": "total-membership-rewards"
}, ae = {
  class: "membership-rewards-table__heading-expires",
  "aria-label": "Expires"
}, re = {
  key: 0
}, te = {
  key: 1,
  class: "membership-rewards-table__expiration-warning"
}, se = /* @__PURE__ */ A(() => /* @__PURE__ */ a("span", {
  "data-ui": "membership-rewards-table-expiring-soon"
}, "Expires soon!", -1)), oe = ["data-ui"], ne = {
  class: "membership-rewards-table__footer"
}, de = /* @__PURE__ */ D({
  __name: "MembershipRewardsTableComponent",
  props: {
    memberRewardData: {
      type: Object,
      required: !0,
      default: null
    },
    rewardsDropExp: {
      type: String,
      default: "control"
    },
    showFooter: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, _ = (/* @__PURE__ */ new Date()).getFullYear(), u = (i) => j.format(i), h = I(() => {
      var i;
      return u(((i = t.memberRewardData) == null ? void 0 : i.memberRewardTotal) || 0);
    }), g = (i, m) => i === "BANKCARD" ? "Earned using your Mastercard, issued as they are posted to your account." : m && m < _ ? `Earned on ${m} purchases, issued by March ${m + 1}.` : `Earned on ${_} purchases, issued by March ${_ + 1}.`, N = (i, m) => m === "BANKCARD" || !i ? "Won't expire for the life of your Mastercard account" : G(i);
    return (i, m) => (l(), b("div", H, [e.memberRewardData ? (l(), y(s(V), {
      key: 0,
      responsive: "",
      border: ""
    }, {
      default: o(() => [a("caption", J, [a("div", Q, [a("div", X, [d(s(c), {
        class: x(["membership-rewards-table__caption__text", "membership-rewards-table__caption__text--large"])
      }, {
        default: o(() => [n(" Available Total "), Z]),
        _: 1
      })]), a("div", ee, w(h.value), 1)])]), a("thead", null, [a("tr", null, [a("th", null, [d(s(c), {
        class: "membership-rewards-table__column-heading"
      }, {
        default: o(() => [n(" Reward ")]),
        _: 1
      })]), a("th", ae, [d(s(c), {
        class: "membership-rewards-table__column-heading"
      }, {
        default: o(() => [n(" Expires ")]),
        _: 1
      })]), a("th", null, [d(s(c), {
        class: x(["membership-rewards-table__column-heading", "membership-rewards-table__column-heading--right"])
      }, {
        default: o(() => [n(" Amount ")]),
        _: 1
      })])])]), a("tbody", null, [(l(!0), b(k, null, E(e.memberRewardData.lineItemList, (r, S) => (l(), b("tr", {
        key: S,
        "data-ui": "membership-rewards-table-row"
      }, [a("td", null, [d(s(c), {
        class: "membership-rewards-table__label"
      }, {
        default: o(() => [n(w(r.rewardYear) + " ", 1), (l(!0), b(k, null, E(r.label.split("®"), (M, v) => (l(), b("span", {
          key: v
        }, [n(w(M), 1), r.label.split("®").length - 1 !== v ? (l(), b("sup", re, "®")) : f("", !0)]))), 128))]),
        _: 2
      }, 1024), d(s(c), {
        class: "membership-rewards-table__note"
      }, {
        default: o(() => [a("span", null, w(g(r.balanceType, r.rewardYear)), 1)]),
        _: 2
      }, 1024)]), a("td", null, [(r.expirationDate || r.balanceType === "BANKCARD") && r.amount !== "Pending" ? (l(), y(s(c), {
        key: 0,
        tag: "span",
        class: "membership-rewards-table__expires"
      }, {
        default: o(() => [n(w(N(r.expirationDate, r.balanceType)), 1)]),
        _: 2
      }, 1024)) : f("", !0), r.expiringSoon && r.amount !== "Pending" && Number(r.amount) > 0 ? (l(), b("div", te, [d(s(Y)), se])) : f("", !0)]), a("td", {
        "data-ui": r.balanceType + "-" + r.expirationDate,
        class: x(["membership-rewards-table__balance", {
          "membership-rewards-table__balance--pending": r.amount === "Pending"
        }])
      }, w(r.amount === "Pending" ? r.amount : u(Number(r.amount))), 11, oe)]))), 128))])]),
      _: 1
    })) : f("", !0), a("div", ne, [d(W, {
      "rewards-drop-exp": e.rewardsDropExp,
      "show-footer": e.showFooter
    }, null, 8, ["rewards-drop-exp", "show-footer"])])]));
  }
});
const ie = /* @__PURE__ */ F(de, [["__scopeId", "data-v-a160c5a3"]]);
export {
  ie as default
};
